class SiteStripe {
    constructor() {
        this.stripe = Stripe(window.data_env.stripe_js_key);
        this.elements = null;
    }

    async initializeSubscriptionSaleForm() {
        const response = await fetch("/sales/setup-intent", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
            }
        });

        const { client_secret: clientSecret, setup_intent_id: setupIntentId } = await response.json();

        if (clientSecret) {
            const appearance = {
                theme: 'flat',
                labels: 'floating',
                variables: {
                    colorPrimary: 'var(--color1)',
                    colorBackground: 'var(--color1-complement)',
                    colorText: 'var(--color1)',
                    gridRowSpacing: '20px'
                },
                rules: {
                    '.Input': {
                        backgroundColor: 'var(--color1-complement)',
                        borderWidth: '2px',
                        borderColor: 'var(--color1)',
                        borderStyle: 'solid',
                        borderRadius: '0',
                        padding: '4px 6px'
                    },
                    '.Tab': {
                        borderRadius: '0'
                    }
                }
            };
            this.elements = this.stripe.elements({
                mode: "setup",
                amount: 0,
                currency: "usd",
                setupIntentClientSecret: clientSecret,
                appearance
            });

            const paymentElementOptions = {
                layout: "tabs",
                disableLink: true
            };

            const formelementsready = {payment: false};
            const paymentElement = this.elements.create("payment", paymentElementOptions);
            paymentElement.mount("#payment-element");
            paymentElement.on('ready', function (event) {
                formelementsready.payment = true;
                if (Object.entries(formelementsready).every(e => !!e[1])) {
                    document.getElementById('payment-form').style.visibility = 'initial';
                    document.getElementById('form-loading-spinner').style.display = 'none';
                }
            });
        } else {
            this.showMessage('Unable to initialize Subscription Payment Gateway');
        }

        return { clientSecret, setupIntentId };
    }

    async confirmSubscription({ returnUrl, clientSecret }) {
        await this.elements.submit();
        const { setupIntent, error } = await this.stripe.confirmSetup({
            clientSecret,
            elements: this.elements,
            confirmParams: {
                return_url: returnUrl
            }
        });

        if (error) {
            this.showMessage(error.message);
            return;
        }

        return setupIntent;
    }

    async initializeOneTimeSaleForm(lineItems, accountId) {
        const response = await fetch("/payment-intent", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
            },
            body: JSON.stringify({
                line_items: lineItems.map((li) => ({
                    sales_product_id: li.sales_product_id,
                    quantity: li.quantity
                })),
                account_id: accountId
            })
        });
        const { client_secret: clientSecret, payment_intent_id: paymentIntentId } = await response.json();
        if (paymentIntentId && clientSecret) {
            const appearance = {
                theme: 'flat',
                labels: 'floating',
                variables: {
                    gridRowSpacing: '20px'
                },
                rules: {
                    '.Input': {
                        borderWidth: '2px',
                        borderStyle: 'solid',
                        borderRadius: '0',
                        padding: '4px 6px'
                    },
                    '.Tab': {
                        borderRadius: '0'
                    }
                }
            };
            this.elements = this.stripe.elements({ appearance, clientSecret });

            const paymentElementOptions = {
                layout: "tabs",
                disableLink: true
            };

            const formelementsready = { payment: false };
            const requiresShipping = lineItems.some((item) => !!item.gps_shipping);
            if (requiresShipping) formelementsready.address = false;

            const paymentElement = this.elements.create("payment", paymentElementOptions);
            paymentElement.mount("#payment-element");
            paymentElement.on('ready', function(event) {
                formelementsready.payment = true;
                if (Object.entries(formelementsready).every(e => !!e[1])) {
                    document.getElementById('payment-form').style.visibility = 'initial';
                    document.getElementById('form-loading-spinner').style.display = 'none';
                }
            });

            if (requiresShipping) {
                const addressElement = this.elements.create("address", { mode: 'shipping' });
                addressElement.mount('#address-element');
                addressElement.on('ready', function(event) {
                    formelementsready.address = true;
                    if (Object.values(formelementsready).every(e => e)) {
                        document.getElementById('payment-form').style.visibility = 'initial';
                        document.getElementById('form-loading-spinner').style.display = 'none';
                    }
                });
            }
        } else {
            this.showMessage('Unable to initialize Payment Gateway');
        }
        return { paymentIntentId };
    }

    async confirmPayment(returnUrl) {
        const { paymentIntent, error } = await this.stripe.confirmPayment({
            elements: this.elements,
            redirect: "always",
            confirmParams: {
                return_url: returnUrl,
            },
        });

        if (error) {
            this.showMessage(error.message);
        }

        return paymentIntent;
    }

    showMessage(messageText) {
        const messageContainer = document.querySelector("#preload-error");
        messageContainer.classList.remove("hidden");
        messageContainer.textContent = messageText;
        setTimeout(function () {
            messageContainer.classList.add("hidden");
            messageContainer.textContent = "";
        }, 5000);
    }

    showForm() {
        document.getElementById('payment-form').style.visibility = 'visible';
    }

    hideForm() {
        document.getElementById('payment-form').style.visibility = 'hidden';
    }
}

export default SiteStripe;